export default __webpack_public_path__ + "static/media/logoBlue.b2a3a789.png";